// extracted by mini-css-extract-plugin
module.exports = {"tablet-landscape-up":"(min-width: calc(1024 * 1px))","wrap":"AvatarStack_wrap__32_8S","image":"AvatarStack_image__1UNhf"};